
import { SectionDefaultProps } from "#app/types/type.ts";
import { cn } from "#app/utils/misc.tsx";
import { HeroSection as Hero } from "#app/types/schema.ts";
import { PageHeader, Text } from "./text";
import SanityImage from "./sanity-image";
import Container from "./container";
import { stegaClean } from "@sanity/client/stega";


type HeroProps = SectionDefaultProps & {
    data: Hero;
};

const headerColors = {
    default: "bg-background text-foreground",
    primary: "bg-primary text-primary-foreground",
    secondary: "bg-secondary text-secondary-foreground",
    muted: "bg-muted text-foreground",
    accent: "bg-accent text-accent-foreground",
}

export default function HeroSection({ data, encodeDataAttribute }: HeroProps) {
    const heroData = stegaClean(data);
    const { heading, tagline, backgroundImage, buttons, backgroundStyle } = heroData;
    const headerClasses = cn(
        "text-center",
        headerColors[backgroundStyle],
    );
    return (
        <>
            <PageHeader heading={heading} variant={backgroundImage ? "servicePage" : "servicesPage"} className={headerClasses}>
                {tagline && (
                    <Text size="lg">
                        {tagline}
                    </Text>
                )}
            </PageHeader>
            {backgroundImage && (
                <div className="relative isolate overflow-hidden">
                    <div className={cn(
                        "w-full absolute -z-[1] h-[224px] md:h-[300px] xl:h-[400px]",
                        backgroundStyle !== "default" ? `bg-${backgroundStyle}` : "bg-background"
                    )} />
                    <Container className="max-w-[390px] py-16 md:py-20 lg:pt-24 lg:pb-28 md:max-w-3xl lg:max-w-5xl">
                        <div className="w-full mx-auto md:w-[90%] lg:76%">
                            <SanityImage
                                image={backgroundImage}
                                alt={heading}
                                sizes="calc(min(100vw - 60px, 1320px) / 1.32)"
                                className="w-full h-auto object-cover rounded-lg aspect-[1.16667/1] md:aspect-[1.67016/1] lg:aspect-[1.66667/1]"
                                disableNaturalAspectRatio
                                loading="eager"
                            />
                        </div>
                    </Container>
                </div>
            )}
        </>
    )
}